import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { closeDialog } from '@Containers/Dialogs/DialogsActions';
import ProjectParametersDialog from '@Pages/RetroSynthesis/ProjectParametersDialog/ProjectParametersDialog';
import SynthesisPlannerService from '@Services/SynthesisPlanner';
import UserDatabases from '@Services/UserDatabases';
import { REDUCER_KEY_RS } from '@Pages/RetroSynthesis/RetroSynthesisProjects/constants';
import { REDUCER_KEY_PROJECT_CREATION_DIALOG } from '@Pages/RetroSynthesis/ProjectParametersDialog/constants';
import {
  cleanOptionsAction,
  fetchAutoplanOptionsAction,
  saveAutoplanOptionsAction,
} from '@Pages/RetroSynthesis/ProjectParametersDialog/action';
import { typeOfRsProjectParametersDialog } from '@Containers/Dialogs/DialogsMapperConstants';
import { addImportProjectsAction, addProjectAction } from '@Pages/RetroSynthesis/RetroSynthesisProjects/actions';
import { useHistory } from 'react-router-dom';
import { IS_LOADING, RESPONSE, VENDORS_INFO } from '@Pages/RetroSynthesis/ProjectParametersDialog/reducer';
import isUndefined from 'lodash/isUndefined';
import { updateParamsForBE } from '../predictiveUtils';

/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
function ProjectParametersDialogContainer({
  closeDialog,
  fetchAutoplanOptionsAction,
  saveAutoplanOptionsAction,
  addProjectAction,
  cleanOptionsAction,
  addImportProjectsAction,
  file,
  ...rest
}) {
  const history = useHistory();

  useEffect(() => {
    fetchAutoplanOptionsAction();
  }, []);

  const submitStructureHandler = ({ rxn, publishedParams, predictedParams, databaseId, structure }) => {
    (async () => {
      const params =
        rxn && databaseId && UserDatabases.isDefaultDatabase(databaseId)
          ? { rxn, publishedParams, predictedParams, databaseId }
          : { structure, publishedParams, predictedParams };
      const updatedProjectParams = updateParamsForBE(params);
      await addProjectAction(updatedProjectParams, { location: history.location });
      SynthesisPlannerService.synthesisProjectCreateAction(history);
    })();
  };

  const submitImportHandler = ({ publishedParams, predictedParams }) => {
    (async () => {
      await addImportProjectsAction({ publishedParams, predictedParams }, file, history.location);
      SynthesisPlannerService.synthesisProjectCreateAction(history);
    })();
  };

  const submitHandler = (...args) => {
    if (file) {
      submitImportHandler(...args);
    } else {
      submitStructureHandler(...args);
    }
    closeDialog({ id: typeOfRsProjectParametersDialog });
    cleanOptionsAction();
  };

  return (
    <ProjectParametersDialog
      {...rest}
      onSubmit={submitHandler}
      onCancel={() => {
        closeDialog({ id: typeOfRsProjectParametersDialog });
        cleanOptionsAction();
      }}
      onSaveAutoplanOptions={(options) => saveAutoplanOptionsAction(options)}
      isImport={!isUndefined(file)}
    />
  );
}

function mapStateToProps(state) {
  const rs = state.get(REDUCER_KEY_RS);
  const projectCreateDialog = rs.get(REDUCER_KEY_PROJECT_CREATION_DIALOG);
  return {
    response: projectCreateDialog && projectCreateDialog.get(RESPONSE),
    vendorsInfo: projectCreateDialog && projectCreateDialog.get(VENDORS_INFO),
    isLoading: projectCreateDialog && projectCreateDialog.get(IS_LOADING),
  };
}

const mapDispatchToProps = {
  closeDialog,
  fetchAutoplanOptionsAction,
  saveAutoplanOptionsAction,
  cleanOptionsAction,
  addProjectAction,
  addImportProjectsAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectParametersDialogContainer);
